import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { Stage2Subsidy } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-stage2-subsidy-report',
  templateUrl: './stage2-subsidy-report.component.html',
  styleUrls: ['./stage2-subsidy-report.component.scss']
})
export class Stage2SubsidyReportComponent implements OnInit {

  stage2_Subsidy: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: Stage2Subsidy[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  public subscriptions: any = [];
  public loading: boolean = false;

  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
        
      this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Stage2_Subsidy_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Stage2_Subsidy_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getStage2_Subsidy_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
             // this.loader.close();
             this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Stage-2 Subsidy Report', '', new Date(), 'Success');

            if (data?.length > 0) {
              this.stage2_Subsidy = data;
              this.appVerificationModel = data;
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.stage2_Subsidy = [];
              this.appVerificationModel = [];
            }
          },
          error: (err) => {
             // this.loader.close();
             this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Stage-2 Subsidy Report', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "District" : d.District,
          "Block" : d.Block,
          "Village": d.Village,
          "App ID": d.AppID,
          "Farmer Name": d.farmerName,
          "Adm Amount": d.Adm_Amount,
          "Farmer Mobile": d.farmer_Mobile,
          "Approval Date": d.Approval_Date,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'District', header: 'District'},
      {field: 'Block', header: 'Block'},
      { field: 'Village', header: 'Village' },
      { field: 'AppID', header: 'App ID' },
      {field: 'farmerName', header: 'Farmer Name'},
      {field: 'Adm_Amount', header: 'Adm Amount'},
      {field: 'farmer_Mobile', header: 'Farmer Mobile'},
      {field: 'Approval_Date', header: 'Approval Date'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

}
